import { useQuery } from '@tanstack/react-query';
import { useApi } from 'common/hooks/api';

export function useVersionHistoryQuery(id) {
  const Api = useApi();
  return useQuery({
    queryKey: ['itinerary', id, 'version-history'],
    queryFn: async () => {
      const response = await Api.getItineraryEvents(id);
      return response?.reverse?.();
    },
    staleTime: 6000,
    cacheTime: 6000,
  });
}
